<template>
  <div v-if="promotions.length > 0" class="flex flex-col">
    <div class="pb-3 sm:pb-6">
      <div class="text-n-0 font-medium sm:font-bold text-base sm:text-xl">
        {{ title }}
      </div>
      <div v-if="subtitle" class="text-n-0 text-sm sm:text-base">
        {{ subtitle }}
      </div>
    </div>
    <div class="relative flex flex-wrap gap-3 overflow-scroll scrolling-touch">
      <div
        v-for="promotion in promotions"
        :key="promotion.id"
        class="relative flex flex-col justify-between w-28 sm:w-52 min-h-32 px-3 sm:px-5 py-2 bg-n-600 menu-product rounded cursor-pointer"
        :class="{
          'bg-v-400': promotion.selected,
          'opacity-50 pointer-events-none':
            (!promotion.isValid || promotion.disabled) && !promotion.selected
        }"
        @click="$emit('promotionSelected', promotion)"
      >
        <div class="flex-1 mb-4">
          <div class="text-sm sm:text-body text-n-0 font-medium">
            {{ promotion.name }}
          </div>
          <div class="text-xs sm:text-sm text-n-0">
            {{ promotion.description }}
          </div>
        </div>
        <div
          v-if="promotion.pointsExpense && promotion.pointsExpense > 0"
          class="text-sm text-n-0 font-bold"
        >
          {{ promotion.pointsExpense }} {{ t('product.points') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import type { CatalogProduct, Promotion } from '@/types'

type CustomExtendedTypeForPromos = {
  pointsExpense: number | null
  selected?: boolean
  isValid?: boolean
  disabled?: boolean
}

type Props = {
  title: string
  subtitle?: string
  promotions:
    | (Promotion & CustomExtendedTypeForPromos)[]
    | (CatalogProduct & CustomExtendedTypeForPromos)[]
}

defineEmits<{
  promotionSelected: [any]
}>()

withDefaults(defineProps<Props>(), {
  subtitle: ''
})

const { t } = useI18n()
</script>
